import React from "react";
import { messages } from "../../PostProduction.messages";
import styles from "./Slide5.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { useFormatMessageRich } from "@src/utils/textFormatting";

export const Slide5: React.FC = () => {
  const formatMessage = useFormatMessageRich();

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          <h3>{formatMessage(messages.G4_P4_S6_G1_Title)}</h3>
          <ul>
            <li>
              {formatMessage(messages.G4_P4_S6_G1_L1_Description)} -{" "}
              <a href="https://www.freetousesounds.com/vr-ambisonic-sound-library" target="_blank" rel="noreferrer">
                {formatMessage(messages.G4_P4_S6_G1_L1_LinkLabel)}
              </a>
            </li>
            <li>
              {formatMessage(messages.G4_P4_S6_G1_L2_Description)} -{" "}
              <a href="https://library.soundfield.com/browse" target="_blank" rel="noreferrer">
                {formatMessage(messages.G4_P4_S6_G1_L2_LinkLabel)}
              </a>
            </li>
            <li>
              {formatMessage(messages.G4_P4_S6_G1_L3_Description)} -{" "}
              <a href="https://ambixes.com/product-category/free/?v=fa868488740a" target="_blank" rel="noreferrer">
                {formatMessage(messages.G4_P4_S6_G1_L3_LinkLabel)}
              </a>
            </li>
          </ul>
          <h3>{formatMessage(messages.G4_P4_S6_G2_Title)}</h3>
          <ul>
            <li>
              {formatMessage(messages.G4_P4_S6_G2_L1_Description)} -{" "}
              <a
                href="https://www.linkedin.com/advice/3/what-some-examples-inspiring-successful-ambisonic?fbclid=IwZXh0bgNhZW0CMTAAAR0iw_O548MQ06YIBID98DZ2AUGRbEZZzEuANNdUZFSwEPp7L0PLLT3_MEM_aem_B45wpUlHEnmhNbVJc9G5dw"
                target="_blank"
                rel="noreferrer"
              >
                {formatMessage(messages.G4_P4_S6_G2_L1_LinkLabel)}
              </a>
            </li>
            <li>
              {formatMessage(messages.G4_P4_S6_G2_L2_Description)} -{" "}
              <a href="https://www.meta.com/en-gb/experiences/1946326588770583/" target="_blank" rel="noreferrer">
                {formatMessage(messages.G4_P4_S6_G2_L2_LinkLabel)}
              </a>
            </li>
            <li>
              {formatMessage(messages.G4_P4_S6_G2_L3_Description)} -{" "}
              <a href="https://www.bbc.co.uk/taster/pilots/turning-forest" target="_blank" rel="noreferrer">
                {formatMessage(messages.G4_P4_S6_G2_L3_LinkLabel)}
              </a>
            </li>
          </ul>
          <h3>{formatMessage(messages.G4_P4_S6_G3_Title)}</h3>
          <ul>
            <li>
              {formatMessage(messages.G4_P4_S6_G3_L1_Description)} -{" "}
              <a href="https://spatialaudiokit.github.io/headtracker/" target="_blank" rel="noreferrer">
                {formatMessage(messages.G4_P4_S6_G3_L1_LinkLabel)}
              </a>
            </li>
            <li>
              {formatMessage(messages.G4_P4_S6_G3_L2_Description)} -{" "}
              <a href="https://supperware.co.uk/headtracker-overview" target="_blank" rel="noreferrer">
                {formatMessage(messages.G4_P4_S6_G3_L2_LinkLabel)}
              </a>
            </li>
            <li>
              {formatMessage(messages.G4_P4_S6_G3_L3_Description)} -{" "}
              <a href="https://spatialmedialab.org/tracker/" target="_blank" rel="noreferrer">
                {formatMessage(messages.G4_P4_S6_G3_L3_LinkLabel)}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
